<div class="language-switcher" (hcClickOutside)="closeDropdown()">
  <button
    type="button"
    class="language-toggle"
    (click)="toggleDropdown()"
    [attr.aria-expanded]="isOpen">
    <img [src]="currentLanguage.flag" [alt]="currentLanguage.name" class="flag-icon">
    <span class="language-name">{{ currentLanguage.name }}</span>
    <lucide-icon [name]="isOpen ? 'chevron-up' : 'chevron-down'"></lucide-icon>
  </button>

  @if (isOpen) {
  <div class="language-dropdown">
    @for (language of languages; track language.code) {
      <button
        type="button"
        class="language-option"
        [class.active]="language.code === currentLanguage.code"
        (click)="selectLanguage(language)">
        <img [src]="language.flag" [alt]="language.name" class="flag-icon">
        <span>{{ language.name }}</span>
      </button>
    }
  </div>
  }
</div>
